export default __webpack_public_path__ + "static/media/kalenday_banner02.757fc4fb.png";